// import React, { useId } from 'react';

// /**
//  * Gift illustration icon (Undraw-style), used on MyAccount and the
//  * post-signup referral screens. Animated: the lid pops open, the ribbon
//  * flares, and confetti dots burst + fade — looping every 2s. Built as a
//  * simple flat-style SVG since the actual Undraw illustration asset was
//  * never ported — replace with the real Undraw SVG if/when one is added
//  * to the project.
//  *
//  * Animation is scoped per-instance via a unique id (useId) so multiple
//  * icons on the same page don't collide on class names, since the
//  * keyframes/classes are injected via an inline <style> tag rather than a
//  * CSS module.
//  */
// const UndrawGiftIcon = ({ width = 96, height = 96 }) => {
//   const rawId = useId();
//   const uid = rawId.replace(/[:]/g, '');

//   return (
//     <svg width={width} height={height} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <style>
//         {`
//           .gift-box-${uid} {
//             transform-box: fill-box;
//             transform-origin: 50% 100%;
//             animation: giftBoxBounce-${uid} 2s ease-in-out infinite;
//           }

//           .gift-lid-${uid} {
//             transform-box: fill-box;
//             transform-origin: 50% 100%;
//             animation: giftLidOpen-${uid} 2s ease-in-out infinite;
//           }

//           .gift-ribbon-v-${uid},
//           .gift-ribbon-h-${uid} {
//             transform-box: fill-box;
//             transform-origin: 50% 50%;
//             animation: giftRibbonGlow-${uid} 2s ease-in-out infinite;
//           }

//           .gift-confetti-${uid} {
//             transform-box: fill-box;
//             transform-origin: 50% 50%;
//             opacity: 0;
//             animation: giftConfettiPop-${uid} 2s ease-out infinite;
//           }

//           .gift-confetti-${uid}:nth-child(1) { animation-delay: 0s; }
//           .gift-confetti-${uid}:nth-child(2) { animation-delay: 0.06s; }
//           .gift-confetti-${uid}:nth-child(3) { animation-delay: 0.12s; }
//           .gift-confetti-${uid}:nth-child(4) { animation-delay: 0.03s; }
//           .gift-confetti-${uid}:nth-child(5) { animation-delay: 0.09s; }
//           .gift-confetti-${uid}:nth-child(6) { animation-delay: 0.15s; }

//           @keyframes giftBoxBounce-${uid} {
//             0%, 30% { transform: translateY(0) scale(1); }
//             42% { transform: translateY(-2px) scale(1.02); }
//             55% { transform: translateY(0) scale(1); }
//             100% { transform: translateY(0) scale(1); }
//           }

//           @keyframes giftLidOpen-${uid} {
//             0%, 28% { transform: translateY(0) rotate(0deg); }
//             42% { transform: translateY(-14px) rotate(-14deg); }
//             58% { transform: translateY(-14px) rotate(-14deg); }
//             75%, 100% { transform: translateY(0) rotate(0deg); }
//           }

//           @keyframes giftRibbonGlow-${uid} {
//             0%, 30% { fill: #fdd835; }
//             42%, 58% { fill: #ffca28; }
//             75%, 100% { fill: #fdd835; }
//           }

//           @keyframes giftConfettiPop-${uid} {
//             0%, 34% { opacity: 0; transform: translate(0, 0) scale(0.3); }
//             46% { opacity: 1; transform: translate(var(--gx), var(--gy)) scale(1); }
//             65% { opacity: 0; transform: translate(calc(var(--gx) * 1.6), calc(var(--gy) * 1.6 - 6px)) scale(0.6); }
//             100% { opacity: 0; transform: translate(0, 0) scale(0.3); }
//           }
//         `}
//       </style>

//       {/* Confetti — small colored dots that burst outward from the lid
//           opening and fade, timed to peak while the lid is open. */}
//       <g>
//         <circle className={`gift-confetti-${uid}`} cx="48" cy="30" r="2.4" fill="#ef5350" style={{ '--gx': '-14px', '--gy': '-10px' }} />
//         <circle className={`gift-confetti-${uid}`} cx="48" cy="30" r="2" fill="#42a5f5" style={{ '--gx': '10px', '--gy': '-14px' }} />
//         <circle className={`gift-confetti-${uid}`} cx="48" cy="30" r="2.2" fill="#66bb6a" style={{ '--gx': '18px', '--gy': '-4px' }} />
//         <rect className={`gift-confetti-${uid}`} x="46.5" y="28.5" width="3" height="3" fill="#ab47bc" style={{ '--gx': '-20px', '--gy': '-2px' }} />
//         <rect className={`gift-confetti-${uid}`} x="46.5" y="28.5" width="3" height="3" fill="#ffa726" style={{ '--gx': '-6px', '--gy': '-18px' }} />
//         <circle className={`gift-confetti-${uid}`} cx="48" cy="30" r="1.8" fill="#26c6da" style={{ '--gx': '4px', '--gy': '-20px' }} />
//       </g>

//       {/* Box base (static) */}
//       <g className={`gift-box-${uid}`}>
//         <rect x="20" y="38" width="56" height="42" rx="4" fill="#ff7043" />
//         <rect x="42" y="38" width="12" height="42" className={`gift-ribbon-v-${uid}`} fill="#fdd835" />
//       </g>

//       {/* Lid + bow — animated: pops up/rotates open, ribbon color pulses */}
//       <g className={`gift-lid-${uid}`}>
//         <rect x="20" y="38" width="56" height="14" rx="2" fill="#e53935" />
//         <rect x="42" y="38" width="12" height="14" className={`gift-ribbon-h-${uid}`} fill="#fdd835" />
//         <path d="M48 38c-6 0-12-4-12-10s4-8 8-8 6 8 4 18z" fill="#fdd835" />
//         <path d="M48 38c6 0 12-4 12-10s-4-8-8-8-6 8-4 18z" fill="#ffe082" />
//       </g>
//     </svg>
//   );
// };

// export default UndrawGiftIcon;

import React, { useId } from 'react';

/**
 * Standalone animated MiniLogo: the two diagonal "fold" shapes that make
 * up the mark (the darker back flap and the brighter front flap) are
 * treated as a pair of wings and flap open/closed continuously — rotated
 * in 3D around their own center via rotateY, with a slight scaleY squash
 * at the extremes for a snappier "wing beat" feel. The white letter marks
 * stay static so the logo still reads clearly at rest.
 *
 * All internal SVG ids (mask, gradients) are namespaced with a unique
 * per-instance suffix (useId) so multiple copies on one page don't
 * collide.
 *
 * Props:
 *   height   — rendered height in px (width follows the logo's own
 *              319:445 aspect ratio). Default 96.
 *   duration — one full flap cycle (out-and-back) in seconds. Default 1.6.
 *   angle    — max rotateY angle per wing, in degrees. Default 22.
 */
const UndrawGiftIcon = ({ height = 96, duration = 1.6, angle = 22 }) => {
  const rawId = useId();
  const uid = rawId.replace(/[:]/g, '');

  const ASPECT = 319 / 445;
  const width = height * ASPECT;

  return (
    <div style={{ width, height, perspective: 600 }}>
      <style>
        {`
          .wing-back-${uid} {
            transform-box: fill-box;
            transform-origin: 50% 50%;
            animation: wingBackFlap-${uid} ${duration}s cubic-bezier(0.45, 0, 0.55, 1) infinite;
          }
          .wing-front-${uid} {
            transform-box: fill-box;
            transform-origin: 50% 50%;
            animation: wingFrontFlap-${uid} ${duration}s cubic-bezier(0.45, 0, 0.55, 1) infinite;
          }

          @keyframes wingBackFlap-${uid} {
            0%, 100% { transform: rotateY(0deg) scaleY(1); }
            50%      { transform: rotateY(${angle}deg) scaleY(0.97); }
          }

          @keyframes wingFrontFlap-${uid} {
            0%, 100% { transform: rotateY(0deg) scaleY(1); }
            50%      { transform: rotateY(${-angle}deg) scaleY(0.97); }
          }
        `}
      </style>

      <svg
        width="100%"
        height="100%"
        viewBox="0 0 319 445"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transformStyle: 'preserve-3d' }}
      >
        <mask id={`mask0-${uid}`} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="319" height="445">
          <path d="M318.638 0H0V444.765H318.638V0Z" fill="white" />
        </mask>
        <g mask={`url(#mask0-${uid})`}>
          {/* Back wing — darker gradient flap */}
          <path
            className={`wing-back-${uid}`}
            d="M252.255 135.692L17.7571 104.928C7.52356 103.28 0 94.4473 0 84.082V377.719C0 386.955 6.34992 394.978 15.3387 397.1L212.425 441.606L219.446 443.263C220.945 443.617 222.382 442.48 222.382 440.94C222.382 432.503 230.225 426.254 238.449 428.139L247.659 430.25C250.011 430.79 252.255 429.002 252.255 426.588V135.692V135.692Z"
            fill={`url(#paint0-${uid})`}
          />
          {/* Front wing — brighter gradient flap + its outline */}
          <g className={`wing-front-${uid}`}>
            <path
              d="M0 376.946V101.182V91.7868C0 79.9572 7.97909 69.6162 19.4218 66.6157L159.319 29.9328L238.978 11.1241L276.595 1.72008L283.616 0.0621043C285.116 -0.292114 286.552 0.845421 286.552 2.38603C286.552 15.1868 292.084 18.8054 304.832 15.1868L314.042 13.0763C316.394 12.5373 318.638 14.3243 318.638 16.738V272.43C318.638 275.517 316.511 278.194 313.509 278.896L297.915 282.534C290.679 284.222 285.661 290.811 285.957 298.238L286.316 307.179C286.45 310.554 284.032 313.492 280.693 314.006L243.417 319.75L168.197 331.867L17.7571 356.099C7.52356 357.748 0 366.582 0 376.946Z"
              fill={`url(#paint1-${uid})`}
            />
            <path
              d="M-4.01769 117.91C0.172624 107.183 9.06362 98.9789 20.0925 95.6629L34.1327 91.4414L252.618 37.0376C266.583 33.5603 280.101 44.1247 280.101 58.5161V242.36C280.101 256.269 270.151 268.188 256.465 270.672L139.548 291.892L69.271 304.648L34.1327 311.025L23.793 312.963C9.02224 315.731 -3.33556 325.804 -9.02561 339.713L-9.85938 341.751"
              stroke="white"
              strokeWidth="6.64031"
            />
          </g>
        </g>

        {/* Letter marks — stay static so the logo reads clearly */}
        <path
          d="M140.862 262.099C138.265 262.099 136.234 260.061 136.234 257.464C136.234 255.64 137.426 254.559 137.993 254.036C138.051 253.985 138.132 253.911 138.184 253.86L138.36 253.507L145.276 246.812C145.857 246.224 146.247 245.348 146.247 243.082V111.01C146.247 108.737 145.857 107.869 145.276 107.28L138.515 100.733L138.36 100.505C138.28 100.424 138.191 100.335 138.103 100.255C137.448 99.6292 136.234 98.4522 136.234 96.6278C136.234 94.0309 138.265 91.9931 140.862 91.9931L164.283 87.9865C184.317 83.9798 197.9 84.4013 204.352 91.9933C210.649 99.4087 213.849 110.238 213.849 124.2C213.849 146.873 207.581 156.989 200.408 162.837C209.737 169.936 214.29 182.383 214.29 200.694C214.29 241.994 193.666 249.598 176.303 254.941L140.862 262.099ZM176.303 236.242C179.4 236.242 182.949 232.671 184.317 228.228C185.833 223.314 186.45 215.001 186.45 199.545C186.45 175.548 178.621 176.227 172.875 176.212V236.242H176.303ZM172.882 158.659C178.885 158.645 186.338 153.016 186.338 124.2C186.338 100.174 179.136 101.256 172.882 101.241V158.659Z"
          fill="white"
        />
        <path
          d="M90.382 270.121C77.3751 270.121 68.3114 259.358 63.4485 238.141C59.2551 219.829 58.7695 196.589 58.7695 180.705C58.7695 164.91 59.2477 146.68 62.8011 131.223C67.561 110.513 76.838 100.008 90.382 100.008C94.2959 100.008 98.5114 101.796 102.903 105.312L102.955 105.356C103.448 105.768 103.882 105.879 104.39 105.893C104.64 105.79 105.294 105.4 106.155 104.415C108.789 101.332 110.783 100.008 112.791 100.008C114.858 100.008 116.506 101.244 117.198 103.318C117.588 104.488 117.639 105.798 117.639 107.041V158.914C117.639 162.387 115.307 164.204 113.012 164.204C111.761 164.204 108.774 163.696 107.994 159.025L107.98 158.951C104.507 134.585 97.6212 117.569 91.2502 117.569C83.2532 117.569 83.2532 157.237 83.2532 180.933C83.2532 212.2 84.3788 231.667 86.7845 242.194C89.1608 252.582 92.2507 252.582 94.5092 252.582C96.7752 252.582 100.615 247.999 103.97 235.087C106.655 224.766 107.7 214.576 107.722 213.811C107.722 210.913 109.848 208.779 112.784 208.779C115.197 208.779 117.632 210.413 117.632 214.069C117.632 232.417 116.035 245.027 112.615 253.752C108.355 264.611 100.873 270.121 90.382 270.121Z"
          fill="white"
        />

        <defs>
          <linearGradient id={`paint0-${uid}`} x1="126.127" y1="84.082" x2="126.127" y2="443.328" gradientUnits="userSpaceOnUse">
            <stop offset="0.492539" stopColor="#270006" />
            <stop offset="1" stopColor="#A3071E" />
          </linearGradient>
          <linearGradient id={`paint1-${uid}`} x1="159.319" y1="55.2404" x2="167.661" y2="288.956" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EF0023" />
            <stop offset="1" stopColor="#D4001D" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default UndrawGiftIcon;